<template>
  <div class="d-flex align-items-center w-100">
    <div class="container-fluid" :class="loginContainer">
      <router-view/>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'

export default {
  computed: {
    loginContainer () {
      return this.$route.name === 'login' ? 'login-container' : ''
    }
  },
  mounted () {
    $('body').attr('class', 'd-flex align-items-center auth-template')
  }
}
</script>
<style scoped>
  .login-container {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  </style>
